let elements
let csrf

export function RfTrack() {
    elements = document.querySelectorAll('.js-rf-track')
    elements = Array.from(elements)

    if (!elements.length) {
        return
    }

    csrf = document.querySelector('meta[name=csrf-token]')
    csrf = csrf.content

    elements.forEach((el) => {
        const validateUrl = el.dataset.validate

        el.addEventListener('submit', (evt) => {
            evt.preventDefault()

            let formData = new FormData(el)

            fetch(validateUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'csrf-token': csrf
                }
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.success) {
                        el.submit()
                        return
                    }

                    const formDataObj = {}
                    for (const pair of formData.entries()) {
                        formDataObj[pair[0]] = pair[1]
                    }

                    const searchParams = new URLSearchParams(formDataObj)
                    searchParams.append('trackError', 'true')
                    window.location.replace('/track?' + searchParams)
                })
        })
    })
}
